import { render, staticRenderFns } from "./AgencyAvatar.vue?vue&type=template&id=66c9071c&scoped=true"
import script from "./AgencyAvatar.vue?vue&type=script&lang=js"
export * from "./AgencyAvatar.vue?vue&type=script&lang=js"
import style0 from "./AgencyAvatar.vue?vue&type=style&index=0&id=66c9071c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c9071c",
  null
  
)

export default component.exports